import React from 'react';

function LogoWithSlogan({ isFooter = false }) {
  return (
    <div className="flex flex-col select-none w-full">
      <div className="flex items-end gap-1.5">
        {/* Logo Image */}
        <img
          src={require("../assets/asdflologoh.png")} 
          alt="asdflo logo"
          className="h-8 sm:h-9 w-auto object-contain"
          style={{ maxWidth: '32px' }}
        />
        
        {/* Logo Text */}
        <span 
          className="text-2xl sm:text-3xl font-bold text-indigo-700 dark:text-indigo-400 leading-none"
          style={{
            fontFamily: 'Poppins, sans-serif',
            letterSpacing: '-0.03em',
            paddingBottom: '2px',
            whiteSpace: 'nowrap'
          }}
        >
          asdflo
        </span>
      </div>
      
      {/* Slogan - positioned below the logo and text */}
      <div className="mt-0.5 ml-1">
        <span 
          className={`text-[10px] font-medium tracking-wider ${isFooter ? 'text-white' : 'text-gray-600 dark:text-gray-300'}`}
          style={{
            fontFamily: 'Montserrat, sans-serif',
            letterSpacing: '0.08em',
            display: 'block',
            lineHeight: '1.2',
            textShadow: '0 1px 1px rgba(255, 255, 255, 0.5)'
          }}
        >
          Together in Neurodiversity
        </span>
      </div>
    </div>
  );
}

export default LogoWithSlogan;
